// @flow

import React from 'react';
import {
    Typography,
    Container,
    Grid,
    Tabs,
    Tab,
    Button,
    TextField,
    IconButton
} from '@material-ui/core';
import TabPanel from '../../components/tabpanel';
import GetScriptContent from '../../data/cms/content/download-scripts';
import SDK from './sdk';
import Scripts from './scripts';
import Dcouments from './documents';
import Searchicons from '@material-ui/icons/Search';
import ClearIcons from '@material-ui/icons/Close';
import './style.css';
import GetApiproductContent from '../../data/cms/content/apiproducts';
import Authentication from '../apiproducts/authentication';
import Binder from '../apiproducts/binder';
import Lists from '../apiproducts/lists';
import Lookup from '../apiproducts/lookups';
import OCR from '../apiproducts/ocr';
import Notifications from '../apiproducts/notifications';
import Billing from '../apiproducts/billing';
import TaxCaddy from '../apiproducts/taxcaddy';
import NoSearchResult from '../../components/search/noresult-search';

function Downloads() {
    const [tempSearchValue, setTempSearchValue] = React.useState("");
    const [searchValue, setSearchValue] = React.useState("");
    const [value, setValue] = React.useState(0);
    const [GetScript, setScriptContent] = React.useState({});
    const [loading, setLoading] = React.useState(true);


    React.useEffect(() => {
        const fetchContent = async () => {
            var fetchedContent = await GetScriptContent();
            setScriptContent(fetchedContent);
            setLoading(false);
            window.scrollTo(0, 0);
        };
        fetchContent();
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const texthandleChange = (event) => {
        if (event.target.value == '') {
            setTempSearchValue("");
            setSearchValue("");
        } else {
            setTempSearchValue(event.target.value);
            setSearchValue(event.target.value);
        }
    };

    const searchBtnOncick = () => {
        setSearchValue(tempSearchValue);
    };

    return (
        <>
            <Grid container className="download">
                <Container>
                    <div className='download-lable'>
                        Downloads
                    </div>
                    <Grid container className="download-content">
                        <Grid container className='searchbox' item lg={12}>
                            <Grid container spacing={0}>
                                <div className='searchborder'>
                                    <div className='colSearch'>
                                        <Searchicons className='searchIcon' />
                                    </div>
                                    <div className='colSearchtxt'>
                                        <TextField id='searchTxtfield'
                                            placeholder="CLICK HERE TO SEARCH DOWNLOADS..."
                                            type="text"
                                            variant="filled"
                                            fullWidth
                                            size="small"
                                            onChange={texthandleChange}
                                            value={tempSearchValue}
                                            InputProps={{
                                                endAdornment: tempSearchValue && (
                                                    <IconButton onClick={() => { setTempSearchValue(""); setSearchValue(""); }}>
                                                        <ClearIcons className='clearIcon' />
                                                    </IconButton>
                                                )
                                            }}
                                        />
                                    </div>
                                    <div className='colsearchBtn'>
                                        <Button className='searchBtn' onClick={searchBtnOncick}>Search</Button>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container className="apiproduct">
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                className="download-nav-bar"
                            >
                                <Typography
                                    component="div"
                                    className="download-nav"
                                >
                                    <Typography
                                        component="div"
                                        className="apiproduct-filter"
                                    >
                                        Filter by:
                                    </Typography>
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        className="download-tabs"
                                        variant="scrollable"
                                    >
                                        <Tab label="SDK's" />
                                        <Tab label="Scripts" />
                                        <Tab label="Documents" />
                                    </Tabs>
                                </Typography>
                            </Grid>
                        </Grid>
                        <TabPanel value={value} index={0} className="tabs">
                            {!loading ? (
                                <SDK props={searchValue} />
                            ) : (' ')}
                        </TabPanel>
                        <TabPanel value={value} index={1} className="tabs">
                            {!loading ? (
                                <Scripts Content={GetScript.Download} searchValue={searchValue} />
                            ) : (' ')}
                        </TabPanel>
                        <TabPanel value={value} index={2} className="tabs">
                            {!loading ? (
                                <Dcouments props={searchValue} />
                            ) : (' ')}
                        </TabPanel>
                    </Grid>
                </Container>
            </Grid>
        </>
    );
};

export default Downloads;
